import AdminOrder from "../app/Admin/AdminOrder";
import Navbar from "../navbar/Navbar";


function AdminOrderPage() {
    return ( 
        <>
         <Navbar>
         <AdminOrder></AdminOrder>
         </Navbar>
        </>
    );
}

export default AdminOrderPage;